const TOKEN_KEY = 'progetto_arca.access_token'
const USER_KEY = 'progetto_arca.user'

export interface StoredUser {
  id: number | null
  email: string
  name: string | null
  role: string
  is_admin: boolean
  whatsapp_enabled?: boolean
  phone?: string | null
  agent_name?: string
}

export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function setAccessToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function getStoredUser(): StoredUser | null {
  try {
    const raw = localStorage.getItem(USER_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<StoredUser>
    if (typeof parsed.email !== 'string') return null
    return {
      id: typeof parsed.id === 'number' ? parsed.id : null,
      email: parsed.email,
      name: typeof parsed.name === 'string' ? parsed.name : null,
      role: typeof parsed.role === 'string' ? parsed.role : 'member',
      is_admin: Boolean(parsed.is_admin),
      whatsapp_enabled: parsed.whatsapp_enabled === true,
      phone: typeof parsed.phone === 'string' ? parsed.phone : null,
      agent_name: typeof parsed.agent_name === 'string' ? parsed.agent_name : 'Luma',
    }
  } catch {
    return null
  }
}

export function storeSession(
  token: string,
  user: {
    id?: number | null
    email: string
    name?: string | null
    role?: string | null
    is_admin?: boolean
    whatsapp_enabled?: boolean
    phone?: string | null
    agent_name?: string | null
  },
): void {
  setAccessToken(token)
  const normalized: StoredUser = {
    id: typeof user.id === 'number' ? user.id : null,
    email: user.email,
    name: user.name ?? null,
    role: user.role ?? 'member',
    is_admin: Boolean(user.is_admin),
    whatsapp_enabled: user.whatsapp_enabled === true,
    phone: user.phone ?? null,
    agent_name: user.agent_name ?? 'Luma',
  }
  localStorage.setItem(USER_KEY, JSON.stringify(normalized))
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}
